/**
 * createPhysicsEngine - factory for configured physics backend instances.
 */

import { RapierPhysicsEngine } from './implementations/RapierPhysics.js';
import { PhysicsEngine } from './PhysicsEngine.js';

import type { IPhysicsEngine, PhysicsOptions } from './PhysicsEngine.js';

/**
 * Create and initialize a physics engine instance.
 * @param options - Physics configuration options
 * @param world - The world instance that owns the physics engine
 * @returns Promise that resolves to physics engine instance or null if failed
 */
export async function createPhysicsEngine(options: PhysicsOptions, world?: any): Promise<IPhysicsEngine | null> {
  let engine: IPhysicsEngine | null = null;
  switch (options.engine) {
    case PhysicsEngine.Rapier:
      engine = new RapierPhysicsEngine(world);
      break;
  }
  if (engine) {
    await engine.create(options);
  }
  return engine;
}
